import React from "react";
import VidareforsaljningPage from "../pages/Vidareforsaljning";
import type { PageKey } from "../lib/menu";

type Props = {
  activePage: PageKey;
  db: any;
  user: any;
  authReady: boolean;
  isCustomerPortal: boolean;
  onOpenItem: (id: string) => void;
};

export function VidareforsaljningView({
  activePage,
  db,
  user,
  authReady,
  isCustomerPortal,
  onOpenItem,
}: Props): JSX.Element | null {
  if (activePage !== "vidareforsaljning") return null;

  return (
    <VidareforsaljningPage
      db={db}
      user={user}
      authReady={authReady}
      isCustomerPortal={isCustomerPortal}
      onOpenItem={onOpenItem}
    />
  );
}
